import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import * as Rx from 'rxjs';
import { HttpClientService } from './httpClient.service';
import { CookieService } from 'ngx-cookie-service';
import {environment} from '../../client/environments/environment';


export class User {
  role: any;
  impersonate: any;
  nbPID: Number;
  PIDLimit: Number;
  firstname: String;
  lastname: String;
  phone: String;
  company: string;
  address: {
    address: String;
    zip: String;
    city: String;
    country: String;
  };
  logo: {
    fileName?: String;
    type: String;
    name: String;
  }
  emailVerified: Boolean;
  email: String;
  fromEmail: String;
  useFromEmail: Boolean;
};

@Injectable()
export class UserService {
  private _baseURL = "/api/users/";
  private _user = new User();

  constructor(private _http: HttpClientService, private _router: Router, private cookieService: CookieService) {
    
  }

  passwordSecured(pwd) {
    var expr = "(?=^.{8,255}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\\d)(?=.*[a-z])|(?=.*[A-Z])(?=.*[a-z])|(?=.*\\d)(?=.*[A-Z]))^.*";
    var pattern = new RegExp(expr);

    return (pwd) ? pattern.test(pwd) : false;
  }

  getUserRoles() {
    let url = this._baseURL + '/roles';

    //noinspection TypeScriptValidateTypes
    return this._http.get(url);/*.subscribe(res => res,
      err => this._handleError(err));*/
  }

  agreeToTerms() {
    let url = this._baseURL + '/agreeToTerms';

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      res => {
        this._user['agreedToTerms'] = true;
        return res;
      }, catchError(this._handleError));
  }

  extendTrial() {
    let url = this._baseURL + '/extend';

    //noinspection TypeScriptValidateTypes
    return this._http.get(url);/*.subscribe(res => res,
      err => this._handleError(err));*/
  }

  changeMyLang(lang) {
    let url = '/api/profiles/me/lang/' + lang;
    this._user['lang'] = lang;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url)/*.subscribe(res => res,
      err => this._handleError(err));*/
  }

  whoAmI() {
    let url = this._baseURL + 'me';

    return Rx.Observable.create(obs => {
      if (!this._user['name']) {

        //noinspection TypeScriptValidateTypes
        this._http.get(url).subscribe(
          /*res => res, err => this._handleError(err))
          .subscribe(*/
          (res: any) => {
            this._user = res;
            obs.next(res);
            obs.complete();
          },
          err => obs.error(err)
        );
      } else {
        obs.next(this._user);
        obs.complete();
      }
    });
  }

  me() {
    return this._user;
  }

  isLoggedIn() {
    return this._user['email'] && this._user['email'].length > 0;
  }

  expired() {
    return this._user['role'] == 'expired';
  }

  logOut() {
    this._user = new User();
    this._router.navigate(['login'], { queryParams: { loggedOut: 'true' } });
  }

  getAllUsers() {
    let url = this._baseURL;
    return this._http.get(url)
  }

  sysinfo() {
    let url = this._baseURL + 'sysinfo';
    return this._http.get(url);
  }

  isAdmin() {
    return this._user && this._user['role'] == 'admin';
  }

  createUser(user) {
    let url = this._baseURL;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify(user), headers);/*.subscribe(res => res,
      err => this._handleError(err));*/
  }

  delete(userID) {
    let url = this._baseURL + userID;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url, headers).subscribe(res => res,
      err => this._handleError(err));
  }

  updatePwd(userID, pwd) {
    let url = this._baseURL + userID + '/password';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(pwd), headers);/*.subscribe(res => res,
      err => this._handleError(err));*/

  }

  update(user) {
    let url = this._baseURL;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(user), headers)/*.subscribe(res => res,
      err => this._handleError(err));*/
  }

  adminEdit(u) {
    let url = this._baseURL + 'force';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(u), headers);/*
      .subscribe(res => res, 
      err => this._handleError(err));*/
  }


  adminSetPassword(u) {
    let url = this._baseURL + 'setPassword';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(u), headers);/*
      .subscribe(res => res, 
      err => this._handleError(err));*/
  }

  sendResetPasswordMail(email) {
    let url = this._baseURL + 'resetPassword';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify({ email: email }), headers);/*
      .subscribe(res => res, 
      err => this._handleError(err));*/
  }

  resetPassword(password, id, token) {
    let url = this._baseURL + 'resetPassword/' + id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify({ newPassword: password, token: token }), headers);
    //.subscribe(res => res, err => this._handleError(err));
  }

  impersonate(user) {
    let url = this._baseURL + 'impersonate/' + user._id;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let self = this;

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, '', headers)
      .pipe(map((res: any) => {
        console.log(url, res.user);

        let token = res.token;
        let tmpUser = self._user;
        self._user = res.user;
        self._user['impersonate'] = true;
        self._user['realUser'] = tmpUser;
        self._user['realUser'].token = this.cookieService.get('token');
        this.cookieService.set('token', res.token, null, '/', environment.domain == "localhost" ? "" : environment.domain, false, 'Lax');

        return res.token;
      }), catchError(this._handleError),);
  }

  stopImpersonate() {
    let tmpUser = this._user['realUser'];

    this.cookieService.set('token', tmpUser.token, null, '/', environment.domain == "localhost" ? "" : environment.domain, false, 'Lax');

    this._user = tmpUser;
  }

  uploadImg(url, file) {
    return Rx.Observable.create(obs => {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.onload = function () {
        if (xhr.status === 200) {
          obs.next("Success");
        } else {
          obs.error("Could not upload file.");
        }
      };
      xhr.onerror = function () {
        obs.error("Could not upload file.");
      };
      xhr.send(file);
    });
  }


  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
